// Copyright (c) 2017 Deere & Company

import ClaimSearchFacetsContainer from './claim-search-facets-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../../../shared/services/get-date-format';

const getStateToBindToContainerProps = state => ({
    dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key),
    facets: {
        ...state.claims.claimSearch.facets,
        claimStatusFacet: {
            ...state.claims.claimSearch.facets.claimStatusFacet,
            allowedStatus: state.user.details.settings.claims.status.selectedStatuses
        },
        dealerAccountsFacet: {
            ...state.claims.claimSearch.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    },
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {queryParams, routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimSearchFacetsContainer);



// WEBPACK FOOTER //
// ./src/claim/claim-search/components/claim-search-facets/index.js